import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: ${theme.typography.bodyFont};
    background-color: ${theme.colors.background};
    color: ${theme.colors.deepNavy};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.typography.headingFont};
    font-weight: 600;
  }
  
  button {
    font-family: ${theme.typography.headingFont};
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    border: none;
    outline: none;
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
`;
